import reducer from './reducers';

export { default as photoAdminSelectors } from './selectors';
export { default as photoAdminOperations } from './operations';
export { default as photoAdminTypes } from './types';

export default reducer;
